import type { FunctionComponent } from "react";
import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
} from "@kanda-libs/ks-design-library";
import PaymentTable from "components/payment/PaymentTable";
import PaymentsInfoBanner from "components/payment/PaymentsInfoBanner";

const PaymentsLayout: FunctionComponent = function () {
  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContent>
        <PaymentsInfoBanner />
        <PaymentTable />
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default PaymentsLayout;
